import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectTextLeft20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObjectTextLeft20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.5 3.5h2a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1m-2.5 1A2.5 2.5 0 0 1 14.5 2h2A2.5 2.5 0 0 1 19 4.5v11a2.5 2.5 0 0 1-2.5 2.5h-2a2.5 2.5 0 0 1-2.5-2.5zM1.048 3.75a.75.75 0 0 1 .75-.75h6.394a.75.75 0 0 1 0 1.5H1.798a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h6.394a.75.75 0 0 1 0 1.5H1.798a.75.75 0 0 1-.75-.75M3.928 6a.75.75 0 0 0 0 1.5h4.274a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h4.274a.75.75 0 0 1 0 1.5H3.927a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectTextLeft20);
